
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import * as actions from '../../actionTypes'
import Login from './Login'
import LanguageSelect from '../language'


const styles = theme => ({
  container: {
    backgroundColor: 'inherit',
    marginTop: 100,
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: theme.desktop.container.bgColor,
      boxShadow: theme.desktop.container.boxShadow,
      borderRadius: theme.desktop.container.borderRadius,
      maxHeight: 500,
      maxWidth: 400,
      paddingTop: theme.spacing.unit * 5
    },
    [theme.breakpoints.up('xs')]: {
      paddingBottom: theme.spacing.unit * 5
    }
  },
  title: {
    textAlign: 'center',
    textTransform: 'none'
  }
})

const renderLanguageSelectForSlot = props => (
  <Grid alignContent="center" container>
    <Grid
      alignItems="center"
      container
      item
      justify="flex-end"
      style={{paddingRight: props.theme.spacing.unit}}
      xs={6}
    >
      <Grid item xs="auto">
        <Typography style={{...props.theme.typography.label}}>{props.t('Select Language')}</Typography>
      </Grid>
    </Grid>
    <Grid item style={{paddingLeft: props.theme.spacing.unit}} xs={6}>
      <LanguageSelect/>
    </Grid>
  </Grid>
)

class LoginContainer extends Component {

  componentWillUnmount() {
    this.props.clearErrors()
  }

  handleChange() {
    if(this.props.errors.invalidCredentials) {
      this.props.clearErrors()
    }
  }

  render() {
    const {classes, t} = this.props
    return (
      <div className={classes.container} id="login-wrapper">
        <Typography variant="title" className={classes.title}>
          {t('Decision Counseling Program')}
        </Typography>
        <Login
          errors={this.props.errors}
          isRequestingAccess={this.props.isRequestingAccess}
          onSubmit={this.props.login}
          onChange={this.handleChange.bind(this)}
          penultSlot={renderLanguageSelectForSlot(this.props)}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  errors: state.authorization.errors,
  isRequestingAccess: state.authorization.isRequestingAccess,
  lang: state.globalSettings.lang
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  clearErrors() {
    const action = {type: actions.CLEAR_LOGIN_ERRORS}
    dispatch(action)
  },
  login(username, password) {
    const action = {type: actions.LOGIN_REQUESTED, payload: {username: username.trim(), password}}
    dispatch(action)
  }
})

export default compose(
  withStyles(styles, {withTheme: true}),
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(LoginContainer)


// WEBPACK FOOTER //
// ./src/components/login/LoginContainer.js